export default __webpack_public_path__ + "static/media/Lauren_Abrams_AHV_In_Moms_We_Trust.f1675d31.jpg";